"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttachmentPickersWrapper = exports.ActionsWrapper = exports.Card = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Card = _interopRequireDefault(require("../Card"));

var _CardContent = _interopRequireDefault(require("../CardContent"));

var _spacing = _interopRequireDefault(require("../../theme/spacing"));

var _colors = _interopRequireDefault(require("../../theme/colors"));

var _muiTheme = _interopRequireDefault(require("../../theme/muiTheme"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    && > * {\n      padding-right: ", ";\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    border-bottom: 1px solid ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var LivaCardStripped = function LivaCardStripped(_ref) {
  var error = _ref.error,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["error"]);
  return /*#__PURE__*/_react["default"].createElement(_Card["default"], rest);
};

var Card = (0, _styledComponents["default"])(LivaCardStripped)(_templateObject(), function (_ref2) {
  var error = _ref2.error;
  return "\n            ".concat(error && "\n                border-color: ".concat(_muiTheme["default"].palette.error.main, ";\n            "), "\n        ");
});
exports.Card = Card;
var ActionsWrapper = (0, _styledComponents["default"])(_CardContent["default"])(_templateObject2(), _colors["default"].lychee[400]);
exports.ActionsWrapper = ActionsWrapper;
var AttachmentPickersWrapper = (0, _styledComponents["default"])(_Grid["default"])(_templateObject3(), _spacing["default"][2]);
exports.AttachmentPickersWrapper = AttachmentPickersWrapper;